

import * as React from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';

import {ThemeClient} from '../contexts/Theme';
import Navbar from '../Navbar';

import ResponsiveEmbed from 'react-responsive-embed'


export default function Chatgpt() {
  return (
    <ThemeClient>
      <Navbar title={'CHAT-GPT'} />
      <div style={{ position: 'relative', width: '100%', paddingTop: 'calc(100vh - 56px)' }}>
        <iframe src="https://www.chatnode.ai/embed/011ffd321f20ebae" style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', border: 'none' }}></iframe>
      </div>
       </ThemeClient>
  );
}
